import { useEffect, useState } from 'react';
import { getSymptomScale } from './api';
import Heatmap, {
  PERIODS, GRANULARITY, DensityLegend, CellPopup,
} from './Heatmap';

export default function SymptomScaleBlock({ petId }) {
  const [months, setMonths] = useState(2);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null); // {row, column, count}

  useEffect(() => {
    setLoading(true);
    setActive(null);
    getSymptomScale(petId, months)
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [petId, months]);

  const columns = data?.columns || [];
  const maxCount = data?.max_count || 0;

  // Подпись на оси может быть сокращена («Темп-ра»), поэтому в подсказке
  // и в aria даём полный состав группы.
  const rows = (data?.groups || []).map(g => ({
    key: g.key,
    label: g.label,
    title: g.symptoms.join(', '),
    symptoms: g.symptoms,
  }));

  const handleCellClick = (row, column, count, details) => {
    setActive(prev =>
      prev && prev.row.key === row.key && prev.column.date_from === column.date_from
        ? null
        : { row, column, count, details }
    );
  };

  return (
    <div className="ss-block">
      <div className="ss-header">
        <div className="ss-title">Прочие симптомы</div>
        <div className="visits-period-tabs ss-tabs">
          {PERIODS.map(p => (
            <button
              key={p.value}
              className={`visits-tab${months === p.value ? ' visits-tab-active' : ''}`}
              onClick={() => setMonths(p.value)}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      {loading && <p className="fr-empty">Загрузка…</p>}

      {!loading && !data && (
        <p className="fr-empty">Не удалось загрузить симптомы</p>
      )}

      {!loading && data && (
        <>
          <p className="ss-note">
            {GRANULARITY[months]} · чем больше отметок, тем темнее клетка.
            Данные из раздела «Самочувствие/Вес → Симптомы».
          </p>

          <Heatmap
            rows={rows}
            columns={columns}
            maxCount={maxCount}
            activeCell={active}
            onCellClick={handleCellClick}
            labelWidth={62}
          />

          {active && (
            <CellPopup
              cell={active}
              rowTitle={active.row.label}
              onClose={() => setActive(null)}
            />
          )}

          {data.total === 0 && (
            <p className="fr-empty ss-empty">
              За выбранный период симптомов не отмечено
            </p>
          )}

          <DensityLegend />

          <div className="ss-scale-legend">
            {rows
              .filter(r => r.symptoms.length > 1)
              .map(r => (
                <div key={r.key} className="ss-scale-legend-item">
                  <span className="ss-scale-legend-key ss-group-key">{r.label}</span>
                  <span className="ss-scale-legend-title">{r.symptoms.join(', ')}</span>
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
}
